import type { ReactNode } from 'react';

export const symbol_format_color_fill: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m320-939 326 327q23 22.8 23 56.5T646-499L468-321q-23 23-54 23t-54-23L182-499q-23-22.77-23-56.44 0-33.66 23-56.44L371-801l-95-95q-9-9.27-8.5-21.64.5-12.36 9.5-21.75 9-8.61 21.5-8.61t21.5 9Zm94 181L215-559h398L414-758Zm287 455.85Q680-323.3 680-353q0-17.35 8-37.17Q696-410 710-431q8-13 19.5-28t22.5-28q11 13 22.5 28t19.5 28q14 21 22 40.83 8 19.82 8 37.17 0 29.7-21.21 50.85-21.21 21.15-51 21.15T701-302.15ZM140 1q-24.75 0-42.37-17.88Q80-34.77 80-59.88 80-85 97.92-102.5 115.84-120 141-120h679q24.75 0 42.38 17.68Q880-84.65 880-59.82 880-35 862.08-17T819 1H140Z"
		/>
	</svg>
);
